import {
    apiConstants,
    config,
    downloadBlob,
    mockResolveApiCall,
    requestOptions,
    requestTypes,
    sendRequest
} from "../../../../Utilities/Api";
import {aphLoanMockData} from "./aphLoanMockData";

class ServerAphLoanApi {

    static getAphItemsReadyForProcessing(aphLoanSearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(aphLoanSearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(config.URL + `aph/loan/?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }

    static updateAphLoanStatuses() {
        return mockResolveApiCall(aphLoanMockData, "");
    }

    static getDropdownListsForAphLoanSearch() {
        const isForLoanManagement = true;
        const queryParameters = new URLSearchParams({isForLoanManagement: String(isForLoanManagement)}).toString();
        return sendRequest(
            requestOptions(config.URL + `aph/loan/dropdown-lists?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }

    static updateAphLoans(aphLoanItems: Record<string, unknown>[]) {
        return sendRequest(
            requestOptions(config.URL + `aph/loan/`,
                requestTypes.PUT,
                JSON.stringify(aphLoanItems),
                apiConstants.successMessage.aphLoan.UPDATE,
            ),
        );
    }

    static getAphLoansReport(aphLoanSearchCriteria: Record<string, unknown>) {
        const params = {
            ...aphLoanSearchCriteria,
        };
        const queryParameters = new URLSearchParams(params as Record<string, string>).toString();
        return downloadBlob(
            requestOptions(config.URL + `aph/reports/loan/export?${queryParameters}`,
                requestTypes.GET,
                null,
                apiConstants.successMessage.report.REPORT_DOWNLOADED,
            ),
        );
    }
}

export const aphLoanApi = config.environment.MODE === config.modes.SERVER ? ServerAphLoanApi : ServerAphLoanApi;
